import { jsx as _jsx } from "react/jsx-runtime";
import { BusyBox } from './BusyBox';
const FlexCol = (props) => {
    return _jsx(BusyBox, Object.assign({ alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }, props), void 0);
};
const FlexGrowCol = (props) => {
    return _jsx(FlexCol, Object.assign({ flexGrow: 1 }, props), void 0);
};
export { FlexCol, FlexGrowCol };
//# sourceMappingURL=FlexCol.js.map